module.exports = __webpack_public_path__ + "img/h2.ff18e0c0.webp";